import React, {useState, useRef, useCallback, useEffect} from "react";
import {EmailShareButton, WhatsappShareButton} from "react-share";

const TagsSection = ({imagesData, tags, setParams, searchImageText, saveSingleImage, getimageData, like}) => {
  const [viewMore, setViewMore] = useState([]);
  const [tagsNewData, setTagsNewData] = useState([]);
  useEffect(() => {
    const images = imagesData?.data?.viewMoreImages;
    let newImages = images?.length > 4 ? images?.slice(0, 4) : images;
    setViewMore(newImages);
  }, [imagesData]);
  useEffect(() => {
    const tagsData = tags?.data?.imageData;
    setTagsNewData(tagsData);
  }, [tags]);
  const download = async (url, name) => {
    let link =
      "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-picture/" + url;
    const a = document.createElement("a");
    a.href = await toDataURL(link);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  };

  const toDataURL = (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };
  const setParamsNew = (url, tag_id, tagTitle) => {
    history.pushState(
      {},
      "",
      "search?searchText=" + url + "&tag_id=" + tag_id + "&tag_title=" + tagTitle
    );
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  return (
    <>
      <div id="t-section-main">
        <div id="t-one-w">
          <div id="t-title">
            {imagesData?.data?.metaData?.metaTitle !== "" &&
            imagesData?.data?.metaData?.metaTitle !== null
              ? imagesData?.data?.metaData?.metaTitle
              : ""}
            <img
              src={like == true ? "../../media/pHeart.svg" : "../../media/grey_heart.svg"}
              alt="Liked heart Icon"
              onClick={() => {
                saveSingleImage(imagesData?.data?.imageData?.id);
              }}
            />
          </div>
          <div id="image-by">
            <span id="nam-t">
              Image By:
              <a
                href={`https://www.bookeventz.com/${imagesData?.data?.imageData?.product_link}`}
                target="_blank"
              >
                <span>
                  {imagesData?.data?.imageData?.RestaurantName !== "" &&
                  imagesData?.data?.imageData?.RestaurantName !== null
                    ? imagesData?.data?.imageData?.RestaurantName
                    : "Blue Cafe Hotel"}
                </span>
              </a>
            </span>
            <span id="nam-v">
              <img
                src="../../media/blackDown.svg"
                alt="Liked heart Icon"
                onClick={() =>
                  download(searchImageText, imagesData?.data?.imageData?.RestaurantName)
                }
              />

              <a
                href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/image-page?imageText=${searchImageText}`}
                data-action="share/whatsapp/share"
                target="_blank"
              >
                <img src="../../media/blackShare.svg" alt="Share Image" />
              </a>
            </span>
          </div>
        </div>
        {viewMore !== undefined &&
          viewMore?.length > 0 && (
            <div id="t-two-w">
            <soan id="t-two-title">
              View more Photos by{" "}
              {imagesData?.data?.imageData?.RestaurantName !== "" &&
              imagesData?.data?.imageData?.RestaurantName !== null
                ? imagesData?.data?.imageData?.RestaurantName
                : "Blue Cafe Hotel"}
            </soan>
            <div id="small-images-section">
              {
                viewMore?.map((v, index) => {
                  let imageAttach = v?.attach_type;
                  let aTypeUrl = "";
                  if (imageAttach == 3) {
                    aTypeUrl =
                      "https://media.bookeventz.com/884x350/html/bookeventz.com/images/banquet-layout/" +
                      v?.image_name;
                  } else if (imageAttach == 1) {
                    aTypeUrl =
                      "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-picture/" +
                      v?.image_name;
                  } else if (imageAttach == 2) {
                    aTypeUrl =
                      "https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-award/" +
                      v?.image_name;
                  } else if (imageAttach == 13) {
                    aTypeUrl =
                      "https://media.bookeventz.com/html/bookeventz.com/images/albums/" + v?.image_name;
                  } else if (imageAttach == 7) {
                    aTypeUrl =
                      "https://media.bookeventz.com/441x272/html/bookeventz.com/images/artist/portfolio/" +
                      v?.image_name;
                  } else if (imageAttach == 6) {
                    aTypeUrl =
                      "https://media.bookeventz.com/441x272/html/bookeventz.com/images/artist/logo/" +
                      v?.image_name;
                  }
                  return (
                    <>
                    { imagesData?.data?.imageData?.attach_type == 13 ? (
                      <>
                      <span id="image-t-here" onClick={() => getimageData(`https://api.bookeventz.com/imageTags/getImageAttachementDetails?image_name=${v?.image_name}`)}>
                      <img src={aTypeUrl} alt="More Photos" />
                      {/* {index == viewMore.length && <span>20 More</span>} */}
                    </span>
                      </>
                    ) : (
                      <>
                      <span id="image-t-here" onClick={() => setParams(v.image_name)}>
                      <img src={aTypeUrl} alt="More Photos" />
                      {/* {index == viewMore.length && <span>20 More</span>} */}
                    </span>
                      </>
                    ) }
                    </>
                  );
                })}
            </div>
          </div>
          )
          }

        { tagsNewData !== undefined &&
          tagsNewData?.length > 0 && (
          <div id="t-three-w">
          <span id="more-tags">Image Tags</span>
          <div id="tags-k-r">
            
              {tagsNewData?.map((tag, index) => {
                return (
                  <span
                    id="not-sel"
                    key={index}
                    onClick={() => setParamsNew(tag.name, tag.id, tag.name)}
                  >
                    {tag.name}
                  </span>
                );
              })}
          </div>
        </div> 
        )}

      </div>
    </>
  );
};

export default TagsSection;
